import AnimatedBackground from '../../components/ui/AnimatedBackground';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A0E27] via-[#1A1F3A] to-[#0A0E27] text-white flex items-center justify-center">
      <AnimatedBackground />

      <div className="relative z-10 text-center px-6 max-w-2xl mx-auto">
        {/* Fezle branding */}
        <div className="mb-8">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm">
            <i className="ri-planet-line text-5xl text-cyan-400"></i>
          </div>
          <h1
            className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent"
            style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          >
            Under Maintenance
          </h1>
          <p className="text-gray-400 text-lg leading-relaxed max-w-lg mx-auto">
            We're making some improvements to bring you a better experience.
            Please check back soon.
          </p>
        </div>

        {/* Status indicator */}
        <div className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-6 inline-block">
          <div className="flex items-center gap-3">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-400"></span>
            </span>
            <span className="text-sm text-gray-300">Maintenance in progress</span>
          </div>
        </div>
      </div>
    </div>
  );
}
